import { inject, Injectable, NgZone, signal } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Observable, Subject } from 'rxjs';
import { AppLifecycleService } from './app-lifecycle.service';

@Injectable()
export class NativeAppLifecycleService extends AppLifecycleService {
  private router = inject(Router);
  private zone = inject(NgZone);
  private active = signal(true);
  private resumedSubject = new Subject<void>();

  readonly isActive = this.active.asReadonly();
  readonly resumed$: Observable<void> = this.resumedSubject.asObservable();

  init(): void {
    App.addListener('appStateChange', ({ isActive }) =>
      this.zone.run(() => {
        const wasActive = this.active();
        this.active.set(isActive);
        if (isActive && !wasActive) {
          this.resumedSubject.next();
        }
      }),
    );

    App.addListener('appUrlOpen', ({ url }) =>
      this.zone.run(() => this.navigateToDeepLink(url)),
    );
  }

  private navigateToDeepLink(url: string): void {
    let parsed: URL;
    try {
      parsed = new URL(url);
    } catch {
      return;
    }
    this.router.navigateByUrl(parsed.pathname + parsed.search + parsed.hash);
  }
}
